import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "userList"]

  openAddMemberModal(event) {
    event.preventDefault()
    this.modalTarget.showModal()
  }

  filterUsers(event) {
    const searchTerm = event.target.value.toLowerCase()
    const userRows = this.userListTarget.querySelectorAll('.user-row')

    userRows.forEach(row => {
      const userName = row.dataset.userName
      if (userName.includes(searchTerm)) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }

  async addMember(event) {
    event.preventDefault()
    const button = event.currentTarget
    const userId = button.dataset.userId
    const groupId = this.element.closest('[data-controller="groups"]')?.dataset.groupId ||
                    window.location.pathname.split('/').pop()

    button.disabled = true
    button.textContent = 'Adicionando...'

    try {
      const response = await fetch(`${window.location.pathname}/add_member`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content || ''
        },
        body: JSON.stringify({ user_id: userId })
      })

      const data = await response.json()

      if (data.status === 'success') {
        window.location.reload()
      } else {
        alert(data.message || 'Erro ao adicionar membro')
        button.disabled = false
        button.textContent = 'Adicionar'
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Erro ao adicionar membro')
      button.disabled = false
      button.textContent = 'Adicionar'
    }
  }

  async updateMemberRole(event) {
    event.preventDefault()
    const button = event.currentTarget
    const userId = button.dataset.userId
    const role = button.dataset.role

    try {
      const response = await fetch(`${window.location.pathname}/update_member_role/${userId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content || ''
        },
        body: JSON.stringify({ role })
      })

      const data = await response.json()

      if (data.status === 'success') {
        window.location.reload()
      } else {
        alert(data.message || 'Erro ao atualizar papel')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Erro ao atualizar papel')
    }
  }

  async removeMember(event) {
    event.preventDefault()
    if (!confirm('Tem certeza que deseja remover este membro?')) {
      return
    }

    const button = event.currentTarget
    const userId = button.dataset.userId

    try {
      const response = await fetch(`${window.location.pathname}/remove_member/${userId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content || ''
        }
      })

      const data = await response.json()

      if (data.status === 'success') {
        window.location.reload()
      } else {
        alert(data.message || 'Erro ao remover membro')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Erro ao remover membro')
    }
  }
}
